var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1331 6.99335L8.81979 5.68001L6.67979 3.54001C6.22646 3.09335 5.45312 3.41335 5.45312 4.05335V8.20668V11.9467C5.45312 12.5867 6.22646 12.9067 6.67979 12.4533L10.1331 9.00001C10.6865 8.45335 10.6865 7.54668 10.1331 6.99335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLinkArrow);
export default __webpack_public_path__ + "static/media/app_link_arrow.d155b2344e537b4deb5518f08357bb24.svg";
export { ForwardRef as ReactComponent };